
export class UserInfoForJurisdictinUpdate{
    id:number;
    userId:string;
    lastUsedJurisdictionId:number;
    constructor(){
        this.id=0;
        this.userId='';
        this.lastUsedJurisdictionId=0;  
    }
}